/* eslint-disable react/prop-types */
import React from 'react';

// Shared card used for selectable option grids in settings popups
// (hour packs, plan tiers, etc.). Centralizing this avoids drift where
// each caller picks its own border color — the previous inline styles
// used either `rgba(255,255,255,0.18)` or `var(--border-default-color)`,
// both of which disappear in light mode.
//
// Border color rationale: a neutral gray rgba renders against both
// light and dark card backgrounds. Selected state uses the Trebble
// accent (#f88923) with a thicker border for clear emphasis.
const SelectableOptionCard = ({
    selected,
    disabled,
    onSelect,
    badge,
    children,
    style,
}) => {
    const handleClick = () => {
        if (disabled) return;
        if (onSelect) onSelect();
    };
    const handleKeyDown = (e) => {
        if (disabled) return;
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (onSelect) onSelect();
        }
    };

    return (
        <div
            className="relative p-4"
            role="button"
            tabIndex={disabled ? -1 : 0}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            style={{
                border: selected
                    ? '2px solid #f88923'
                    : '1px solid rgba(128,128,128,0.35)',
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.4 : 1,
                background: selected ? 'rgba(248,137,35,0.08)' : 'transparent',
                ...style,
            }}
        >
            {badge && (
                <div
                    className="absolute top-2 right-2 text-xs uppercase px-1.5 py-0.5"
                    style={{
                        background: '#f88923',
                        color: '#fff',
                        letterSpacing: '0.5px',
                    }}
                >
                    {badge}
                </div>
            )}
            {children}
        </div>
    );
};

export default SelectableOptionCard;
